import Cookies from 'universal-cookie';
const cookies = new Cookies();
export default cookies;

export enum CookieKey {
  StickyFooter = 'stickyFooter',
}
export enum CookieValue {
  StickyFooter = 'shown',
}
